<template>
    <div>
        <template v-if="manage_administrator === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Administrators</h1>
                <router-link to="/addAdministrator" class="btn btn-primary float-right active"> Add Administrator</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
            </div>
            <table id="administratorTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Cnic</th>
                        <th>Email</th>
                        <th>Company</th>
                        <th>Mobile</th>
                        <th>City</th>
                        <th>Status</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="manage_administrator === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="manage_administrator === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                manage_administrator: null,
                editAdministrator:false
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('manage_administrator|edit_administrator').then(result => {
                this.manage_administrator = result.manage_administrator;
                this.editAdministrator    = result.edit_administrator
            }).then(result => {
                if(this.manage_administrator == true){
					this.callDataTable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            callDataTable(){
                var that = this;
                var administratorTable = $('#administratorTable').DataTable({
                    processing: true,
                    serverSide: true,
                    searching: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    ajax: {
                        "url": "api/listAdministrators",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records"
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id'},
                        {data: 'name'},
                        {data: 'cnic'},
                        {data: 'email'},
                        {render: function(data,type,full){
                            if(full.companyname != null){
                                return full.companyname;
                            }
                        }},
                        {data: 'mobile_no'},
                        {render: function(data,type,full){
                            if(full.city != null){
                                return full.city;
                            }
                        }},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            if( that.editAdministrator){
                                var $url = '/editAdministrator/'+full['id'];
                                return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                            }else{
                                return '';
                            }
                        }}
                    ],
                    drawCallback: function(settings){
                        $(".action").tooltip();
                    },
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 7 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                $('#customSearch').on( 'keyup', function (e) {
                    if (e.keyCode === 13) {
                        administratorTable.search(this.value).draw();
                    }
                });
            }
        }
    }
</script>
